module.exports = __webpack_public_path__ + "static/media/icn_mainnav_search_small.8ed51eeb.svg";